import { Chip, SxProps, useTheme } from "@mui/material";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { CohortMemberStatus } from "generated-graphql/graphql";
import {
  CohortDisplayStatus,
  memberStatusToSx,
  statusToSx,
} from "util/cohortStatus";

export function CohortStatusChip({ status }: { status: CohortDisplayStatus }) {
  const theme = useTheme();
  const stylingBlock = statusToSx(status, theme);

  return (
    <StyledStatusChip
      sx={stylingBlock}
      displayStatus={prettyPrintEnumValue(status)}
    />
  );
}

export function CohortMemberStatusChip({
  status,
}: {
  status: CohortMemberStatus;
}) {
  const theme = useTheme();
  const stylingBlock = memberStatusToSx(status, theme);

  return (
    <StyledStatusChip
      sx={stylingBlock}
      displayStatus={prettyPrintEnumValue(status)}
    />
  );
}

const StyledStatusChip = ({
  sx,
  displayStatus,
}: {
  sx: SxProps | null;
  displayStatus: string;
}) => {
  if (!sx) {
    return <Chip label={displayStatus} size="small" variant="outlined" />;
  }

  return <Chip label={displayStatus} size="small" variant="filled" sx={sx} />;
};
